import {
  ArrowLeftIcon,
  ArrowRightIcon,
  Button,
  Flex,
} from '@iheartjane/reefer';
import { useContext, useRef } from 'react';

import type { CarouselThumbnailProps } from '../carousel.types';
import { CarouselContext } from '../context';
import {
  ThumbnailButtonWrapper,
  ThumbnailRowWrapper,
  ThumbnailsWrapper,
} from './carouselThumbnail.styles';
import { CarouselThumbnailItem } from './carouselThumbnailItem';

/**
 * Carousel Thumbnails to view and select product or brand media
 */

export const CarouselThumbnails = ({
  activeIndex,
  isLightbox,
  items,
  updateIndex,
  variant,
}: CarouselThumbnailProps) => {
  const { desktopWidth } = useContext(CarouselContext);
  const showButtons = !isLightbox && variant !== 'brand' && items.length > 4;
  const thumbnailRefs = useRef<HTMLDivElement[]>([]);

  const handleClick = (newIndex: number) => {
    updateIndex(newIndex);
    thumbnailRefs?.current[newIndex]?.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'center',
    });
  };

  return (
    <ThumbnailsWrapper
      isLightbox={isLightbox}
      data-testid="carousel-thumbnails"
    >
      {showButtons && (
        <ThumbnailButtonWrapper>
          <Button.Icon
            icon={<ArrowLeftIcon />}
            label="View previous item"
            variant="minimal-inverse"
            mr={12}
            disabled={activeIndex === 0}
            onClick={() => handleClick(activeIndex - 1)}
          />
        </ThumbnailButtonWrapper>
      )}
      <ThumbnailRowWrapper maxWidth={desktopWidth} isLightbox={isLightbox}>
        {items.map((item, index) => {
          return (
            <Flex grow key={index}>
              <CarouselThumbnailItem
                {...item}
                activeIndex={activeIndex}
                thumbnailIndex={index}
                updateIndex={handleClick}
                thumbnailRef={(element: HTMLDivElement) => {
                  thumbnailRefs.current[index] = element;
                }}
              />
            </Flex>
          );
        })}
      </ThumbnailRowWrapper>

      {showButtons && (
        <ThumbnailButtonWrapper>
          <Button.Icon
            icon={<ArrowRightIcon />}
            label="View next item"
            variant="minimal-inverse"
            ml={12}
            disabled={activeIndex === items.length - 1}
            onClick={() => handleClick(activeIndex + 1)}
          />
        </ThumbnailButtonWrapper>
      )}
    </ThumbnailsWrapper>
  );
};
